<template>
  <div class="w-100 list-group mb-3  bg-white">
    <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
      <div class="fw-bold  my-0 lh-base h6" >个人中心 / 我发布的成果</div>
      <div class="d-flex align-items-center">
        <div class="selected-box my-0 lh-base d-flex align-items-center me-2">
          <label for="sele1" class="flex-shrink-0 text-secondary small">筛选：</label>
          <select class="form-select form-select-sm  rounded-0 " @change="getList(true)" v-model="params.status" id="sele1" aria-label="请选择" >
            <option value="">全部</option>
            <option value="0">审核中</option>
            <option value="1">已发布</option>
            <option value="2">未通过</option>
            <option value="3">已撤销</option>
          </select>
        </div>
        <button @click="openAnnounceAchi"  class="btn btn-sm btn-primary me-1 flex-shrink-0" type="button">
          <i class="bi bi-send-fill me-1"></i>
          发布成果</button>
      </div>

    </div>
    <!--没有数据-->
    <NodataCom :show="showNodata"></NodataCom>
    <!--  正在加载-->
    <LoadingCom :show="showLoading"></LoadingCom>
    <!--    列表-->
    <div class="p-2 list-box border-bottom px-2 mx-1 py-2" v-for="(item,index) of list" :key="index">
      <div class="d-flex align-content-center justify-content-between  rounded-2 mb-2">
        <div class=" w-auto my-0 lh-base " >
          <div class="fw-bold title-left me-3 point-curser pub-hover-primary" @click="goto(item)">{{item.Name}}</div>
        </div>
        <span class="badge title-badge badge-blue-green rounded-pill px-2 flex-shrink-0" v-if="item.Status===0">审核中</span>
        <span class="badge title-badge badge-little-lightblue rounded-pill px-2 flex-shrink-0" v-else-if="item.Status===1">已发布</span>
        <span class="badge title-badge text-bg-warning text-white rounded-pill px-2 flex-shrink-0" v-else-if="item.Status===3">已撤回</span>
        <div v-else-if="item.Status===2" class="flex-shrink-0">
          <a class="btn-link text-danger-red me-3 small point-curser" v-if="item.Status===2">原因</a>
          <span class="badge title-badge badge-red-blue rounded-pill px-2 " >未通过</span>
        </div>
      </div>
      <div class="row g-2">
        <div class="col-12 col-md-7 d-flex align-items-center justify-content-start flex-wrap">
          <small class="small me-3 text-body-secondary mb-1">发布时间：{{item.CreatedAtdeal}}</small>
        </div>
        <div class="col-12 col-md-5 d-flex align-items-center justify-content-end">
          <!--            <button type="button" class="btn btn-outline-danger btn-sm small-btn-size" v-if="item.statue===3">原因</button>-->
          <button type="button" class="btn btn-link text-decoration-none fw-bold btn-sm small-btn-size" @click="quiteAction(item)" v-if="item.Status===0">取消预约</button>
          <button type="button" class="btn btn-link text-decoration-none fw-bold btn-sm small-btn-size" @click="goto(item)" v-else-if="item.Status===1">查看详情</button>
          <button type="button" class="btn btn-link text-decoration-none fw-bold btn-sm small-btn-size" v-if="item.Status===2 || item.Status===3" @click="goEdit(item)">编辑</button>
<!-- 删除-->
          <!--          <button type="button" class="btn btn-link text-danger-red text-decoration-none fw-bold btn-sm small-btn-size" v-if="item.Status===2 || item.Status===3">删除</button>-->
        </div>
      </div>
    </div>

  </div>

  <PaginationCom
      @pageChange="pageChangeFun($event)"
      :totalIn="total"
      :currentIn="params.current"
      :pageSizeIn="params.pageSize"
  ></PaginationCom>

  <!--  撤销需求确认框-->
  <div class="modal fade" ref="quitModel" id="quitModel" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title fw-bold" id="exampleModalToggleLabel2">取消预约</div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          确定要取消预约吗?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="callbackState">取消</button>
          <button type="button" class="btn btn-primary" :disabled="callbackState" @click="quite">
            <div class="spinner-border spinner-border-sm" role="status" v-if="callbackState">
              <span class="visually-hidden">Loading...</span>
            </div>
            确定
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
// import AnnounceAchievementsModel from "@/components/AnnounceAchievementsModel"
import NodataCom from "@/layout/NodataCom"
import LoadingCom from "@/layout/LoadingCom"
import {onMounted, reactive, ref} from "vue";
import {getMyResults} from "@/api/Result";
import router from "@/router";
import {formatTime} from "@/utils/dateFun";
import {showToast} from "@/utils/toast";
import {cancelResult} from "@/api/Result";
import {Modal} from "bootstrap";
const callbackState = ref(false);
let quitModelRef = "" // 取消模态框 实例
const quitModel = ref() // 取消模态框 dom
let choisedItem = ""; // 被选中的要操作的
const params = reactive({
  current:1,
  pageSize:10,
  status:""
})
const total  = ref(0)
// 发布成果
// const showAnnounceAchievementsModel = ref(false)
// 发布成果
const openAnnounceAchi = ()=>{
  // showAnnounceAchievementsModel.value = true
  router.push({path:"/supplyadd"})
}
const list = ref({})
const showNodata = ref(false)
const showLoading = ref(false)
onMounted(()=>{
  getList()
})
const pageChangeFun = (e)=>{
  params.current = e.page
  params.pageSize = e.pageSize
  getList()
}
// 获取消息列表
const getList = async (currentinit)=>{
  if(currentinit){
    params.current = 1
  }
  showLoading.value = true
  showNodata.value = false
  list.value = []
  total.value = 0
  const query = {current:params.current,pageSize:params.pageSize}
  if(params.status!==""){
    query.status = params.status
  }
  const res =await getMyResults(query)
  showLoading.value = false

  if(res.err_code==0){
    const data =  res.data || []
    data.forEach(item=>{
      if(item.CreatedAt){
        item.CreatedAtdeal = formatTime(item.CreatedAt)
      }
    })
    list.value = data
    total.value = res.total || 0
    if(data.length<=0){
      showNodata.value = true
    }
  }else{
    showToast("danger",res.err_msg || "请求出错")
  }
}
// 跳转
const goto = (item) => {
  router.push({path:'/mySupplyDetail',query:{id:item.ID}})
}
// 编辑
const goEdit= (item) => {
  router.push({path:'/supplyedit',query:{id:item.ID}})
}
const showModel = ()=>{
  if(!quitModelRef){
    quitModelRef = new Modal(quitModel.value);
  }
  quitModelRef.show();
}

const hideModel = ()=>{
  if(!quitModelRef){
    quitModelRef = new Modal(quitModel.value);
  }
  quitModelRef.hide();
}
// 取消预约打开
const quiteAction =  (item)=>{
  showModel()
  choisedItem = item
  callbackState.value = false
}
const quite = async ()=>{
  callbackState.value = true
  const res = await cancelResult({id:choisedItem.ID})
  callbackState.value = false
  if(res.err_code==0){
    const index = list.value.findIndex(item=>item.ID===choisedItem.ID)
    list.value[index].Status = 3
    hideModel()
    return showToast("success","撤销成功")
  }else{
    return showToast("danger",res.err_msg || "请求出错")
  }
}
</script>

<style scoped lang="scss">

.title-left{
  word-break: break-all;
}
.title-badge{
  height: 1.5rem;
  line-height: 1rem;
  font-size: 0.7rem;
  font-weight: normal;
  width: 5rem;
}
.small{
  font-size: 0.9rem;
}
.list-box{
  box-sizing: border-box;
}

.small-btn-size{
  height: 1.5rem;
  line-height: 1rem;
}

.btn-check + .btn{
  border: none;
}
.btn-check:checked + .btn{
  color: #0d6efd;
}


</style>
